import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import './css/App.css';
import CorePage from './views/core/CorePage';
import ErrorPage from './views/core/ErrorPage';
import LessonView from './views/lesson/LessonView';
import ResetPasswordForm from './views/login/ResetPasswordForm';
import ExternalLogin from './views/extlogin/ExternalLogin';
import LumosLogin from './views/extlogin/LumosLogin';
import VendorLogin from './views/extlogin/VendorLogin'; 
import OpenLessonView from './views/lesson/OpenLessonView';
import MozartView from './views/lesson/MozartView';

import PreloginHome from './views/contest/ContestPreLoginHome';

import ComponentRegistry from './model/ComponentRegistry';
import UserStore from './util/UserStore';

import DummyPage from './views/temp/TestComplete';
import './track/CouponTracker';
import './util/Ga';

class App extends CorePage {

  constructor(props){
    super(props);
    this.userStore = new UserStore();
  }

  getCmpHelper(){
    return super.getCmpHelper(this.userStore);
  }

  getComponent(cmpName, defaultCmpName=null){
    return this.getCmpHelper().getCmp(cmpName, defaultCmpName);
  }

  getPreLoginComponent(cmpName){
    const origin = this.getBasePath();

    if(origin && origin.toLowerCase().match("contest")){
        return this.getComponent("contest_"+cmpName, cmpName);
    }

    return this.getComponent(cmpName);
  }

  render() {
    return (
      <Router>
      <Switch>
      <Route path="/" component={PreloginHome} />
      <Route path='/login' exact component={PreloginHome}/>
      <Route path="/lessonview/:id" exact component={LessonView} />   
      <Route path="/mozartview/:lid" exact component={MozartView} />  
      <Route path="/openlessonview/:id" exact component={OpenLessonView} /> 
      <Route path="/forgotPassword/:id" exact component={ResetPasswordForm} />
      <Route path="/extlogin" component={ExternalLogin} />
      <Route path="/lumos" component={LumosLogin} />
      <Route path="/vendorlogin" component={VendorLogin} />
      <Route path="/800" exact component={DummyPage} />
      <Route path="/404" exact component={ErrorPage} />
      <Route component={PreloginHome} />
      <Redirect from='*' to='/' />
      </Switch>
      </Router>
	  
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js